

require("xo-ui-components/src/accessibility/directive");
var _template = _interopRequireDefault(require("./template"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('itemDetails', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      details: '=?',
      sku: '=?',
      currencyCode: '=?',
      onClickLess: '&?'
    },
    controller: function controller() {/* dumb component */}
  };
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/cart/itemDetails/directive.js
// module id = ../node_modules/xo-page-components/src/cart/itemDetails/directive.js
// module chunks = 0